import React, { useEffect, useState } from 'react';
import './home-styles/home-section1.scss';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { database } from '../../firebase';
import { ref as dbRef, onValue } from 'firebase/database';

import expert from "../../assets/images/expert_image.jpeg";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
};

const HomeSection1 = () => {
  const [carouselImages, setCarouselImages] = useState([]);

  useEffect(() => {
    const imagesRef = dbRef(database, 'uploadimages');

    const unsubscribe = onValue(imagesRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const allImages = Object.values(data)
          .flatMap((entry) => entry.images || []);
        setCarouselImages(allImages);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className='home-section1'>
      <div className="section dark-section">
        <div className='row first-section'>
          <div className='row heading-row d-flex justify-content-center align-items-center text-center'>
            <h2 className='academy-header'>BRIGHT FUTURE GOLD APPRAISER</h2>
            <h2 className='academy-header'>TRAINING ACADEMY</h2>
          </div>

          <div className='row justify-content-center mt-4'>
            <div className='carousel-container'>
              <Slider {...settings}>
                {carouselImages.map((img, index) => (
                  <div key={index}>
                    <img src={img} alt={`carousel-${index}`} className="carousel-image" />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>

        <div className='row second-section flex-column flex-md-row' style={{ marginTop: '5rem' }}>
          <div className='col-12 col-md-4 d-flex justify-content-center align-items-center mb-4 mb-md-0'>
            <div className='text-center d-flex flex-column align-items-center'>
              <img src={expert} alt="round" className="round-image" />
              <p className='expert-name mt-3'>Mr. DINESH KUMAR</p>
            </div>
          </div>

          <div className='col-12 col-md-8'>
            <div className='row d-flex justify-content-center align-items-center text-center text-md-start'>
              <div className='side-heading'>
                <h4>Master of Gold valuation & Lead the Jewel Industry</h4>
              </div>
            </div>

            <div className='row'>
              <div className='col-12 text-center text-md-start'>
                <p className='appraisal-expert'>Our Appraisal Expert</p>
              </div>

              <div className='col-12 experince text-center text-md-start'>
                <p>With 18+ Years of Industry Experience of jewellery industry & Gold Appraiser became manager in NBFC</p>
              </div>

              <div className='row experience-container d-flex justify-content-center'>
                <ul className='experience-list'>
                  <li>Career started in Emerald Jewel Industry (2007 - 2011)</li>
                  <li>Shriram City Union Finance (2012 - 2016)</li>
                  <li>Appraiser Training Lecturer (2017 - Present)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSection1;
